export const SubHeading = () => {
  return (
    <div
      css={`
        padding: 0 20px 32px;
        line-height: 36px;
        font-size: 20px;
        font-family: "Pretendard", sans-serif;
        font-weight: 300;
        letter-spacing: -0.24px;

        @media (min-width: 960px) {
          padding: 0 0 40px;
          line-height: 40px;
          font-size: 28px;
          font-family: "Pretendard", sans-serif;
          letter-spacing: -0.336px;
        }
      `}
    >
      Create your free account, no credit card needed
    </div>
  );
};
